import axios from 'axios';

// axios.defaults.timeout = 0; //请求超时5秒
// axios.defaults.baseURL = 'https://tclient.souyisi.com/'; //请求base urls
// axios.defaults.baseURL = 'https://qzdacheng.souyisi.com/'; //请求base urls
axios.defaults.baseURL = 'https://tapi.souyisi.com:7149/'; //请求base url  测试环境
// axios.defaults.baseURL = 'https://lg.sjw.qz.gov.cn:6082/' //   正式环境
//axios.defaults.baseURL = '/proxy'; //请求base url
// axios.defaults.headers.post['Content-Type'] = 'application/json'; //设置post请求是的header信息

//http request 拦截器
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem('token')
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = token;
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)
//返回拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 4003) {
            // Toast({
            //     mes: '您没有权限操作！',
            //     timeout: 1500,
            //     callback: () => {
            //         router.go(-1);
            //     }
            // });

            return false;
        }
        if (response.data.code === 1009) {
            sessionStorage.removeItem('token')
            // location.reload()
            // router.push({
            //     path: "/login",
            //     querry: { redirect: router.currentRoute.fullPath }//从哪个页面跳转
            // })

        }
        return response
    },
    err => {
        // if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
        //     Toast({
        //         mes: '网络异常，连接超时...',
        //         timeout: 1500
        //     });
        // }
        return Promise.reject(err)
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params={}, headers={}){
    return new Promise((resolve, reject) => {
    axios.get(url,{
     params: params,
     headers: headers
    })
    .then(response => {
     resolve(response.data);
    })
    .catch(err => {
     reject(err)
    })
    })
   }

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
 
 export function post(url, data = {},header){
    return new Promise((resolve, reject) => {
     axios.post(url, data,header)
     .then(response => {
     resolve(response.data);
     }, err => {
     reject(err)
     })
    })
    }


// WEBPACK FOOTER //
// ./src/utils/http.js